import React from 'react';

import styled from 'styled-components';

import Picture from 'components/picture';

const ImageContainer = styled.div`
  width: 90%;
  max-width: 920px;
  margin: 0 auto;
  padding: 2.5rem 0rem;
  ${Styles.mobile`
    padding: 1.5rem 0rem;
  `}
`;
const Figure = styled.figure`
  position: relative;
  margin: 0;
`;
const Image = styled(Picture)`
  border-radius: ${Styles.borderRadius};
`;
const ImageCaption = styled.figcaption`
  padding-top: 1rem;
  font-size: 0.875rem;
  & > a {
    color: ${Styles.color.primary};
    margin-right: 0.5rem;
  }
`;

export default class ImageWidget extends React.Component {
  render() {
    return (
      <ImageContainer>
        <Figure>
          <Image image={this.props.image?.locale} />
        </Figure>
        {this.props.caption && (
          <ImageCaption>
            {this.props.attributionLink && <a href={this.props.attributionLink}>Image Source</a>}
            {this.props.caption?.locale}
          </ImageCaption>
        )}
      </ImageContainer>
    );
  }
}
